<template>
  <div class="app-input"
       :class="{
         'app-input_has-prepend': $slots.prepend,
         'app-input_has-append':$slots.append,
         'app-input_danger': danger
       }"
  >
    <label class="app-input__label" :for="_uid" v-if="label">
      {{ label }}
    </label>
    <div class="app-input__body">
      <div class="app-input__prepend" v-if="$slots.prepend">
        <slot name="prepend" />
      </div>
      <div class="app-input__input">
        <input :id="_uid" v-model="model" v-bind="$attrs" v-on="listeners" ref="input">

        <div class="app-input__input-icons" v-if="$slots.icons">
          <slot name="icons" />
        </div>

      </div>
      <div class="app-input__append" v-if="$slots.append">
        <slot name="append" />
      </div>
    </div>
    <transition name="fade">
      <div class="app-input__validation-error" v-if="danger && dangerText.length">
        {{ dangerText }}
      </div>
    </transition>
  </div>
</template>

<script>
import $validateInput from "@/globalFunctions/validateInput";

export default {
  name:     "AppInput",
  props:    {
    value:      {},
    label:      {
      type: String,
    },
    danger:     {
      type:    Boolean,
      default: false,
    },
    dangerText: {
      type:    String,
      default: "",
    },
    vtype:      { //validator type
      type:    String,
      default: 'text',
    },
  },
  computed: {
    listeners() {
      return {
        ...this.$listeners,
        keypress: ( evt ) => {
          let keyCode = evt.which ? evt.which : evt.keyCode;
          if (keyCode === 13) {
            this.$emit('enterPressed', evt);
            return false;
          }
          $validateInput(evt, this.vtype);
        },
        input:    ( evt ) => {
          this.model = evt.target.value;
        },
        change:   ( evt ) => this.change(evt),
      };
    },
    model: {
      get() {
        return this.value;
      },
      set( v ) {
        let value = v.length === 0 ? null : v;
        if (value !== null && (this.vtype === 'double' || this.vtype === 'udouble')) {
          value = value.replace(/,/g, '.');
        }
        this.$emit('input', value);
        this.$emit('update:danger', false);
      },
    },
  },
  methods:  {
    change() {
      let v = this.$refs.input.value;
      let value = v.length === 0 ? null : v;
      if (value !== null && (this.vtype === 'double' || this.vtype === 'udouble')) {
        value = value.replace(/,/g, '.');
      }
      this.$emit('change', value);
    },
    focus() {
      this.$refs.input.focus();
    },
  },
};
</script>

<style lang="scss">
.app-input {
  position: relative;

  &__label {
    color: rgba(var(--app-label-color), 1);
    font-size: 1rem;
    margin-bottom: 2px;
    display: block;
  }

  &__body {
    display: flex;
    height: 36px;
    border: 1px solid #ced4da;
    border-radius: 2px;
  }

  &_danger {
    .app-input__body {
      border: 1px solid rgba(var(--app-danger), 1);
    }
  }

  &__input {
    flex: 1;
    position: relative;

    input {
      appearance: none;
      display: block;
      width: 100%;
      max-width: 100%;
      padding: 5px 10px;
      border: none;
      border-right-color: transparent;
      font: inherit;
      font-size: 1rem;
      border-radius: 2px;
      height: 100%;
      color: rgba(var(--app-content-color), 1);

      &:disabled {
        opacity: .5;
      }

      &::placeholder {
        color: #ced4da;
      }

      &[readonly] {
        opacity: .7;
      }
    }

    &-icons {
      position: absolute;
      top: 50%;
      transform: translateY(-50%);
      right: 10px;
      display: flex;
      align-items: center;
      justify-content: center;
    }

  }

  &__append, &__prepend {
    display: flex;
    align-items: center;
    justify-content: center;
    background-color: #f8f9fa;
    user-select: none;
    padding: 0 1rem;
    color: #47404f;
  }

  &__append {
    border-left: 1px solid #ced4da;
  }

  &__prepend {
    border-right: 1px solid #ced4da;
  }

  &_has-prepend {
    .app-input__input input {
      border-top-left-radius: 0;
      border-bottom-left-radius: 0;
    }
  }

  &_has-append {
    .app-input__input input {
      border-top-right-radius: 0;
      border-bottom-right-radius: 0;
    }
  }

  &__validation-error {
    display: inline-block;
    color: rgba(var(--app-danger), 1);
    overflow: hidden;
    transition: all .25s ease;
    border: 1px solid #eee;
    background: #fff;
    box-shadow: 0 10px 12px rgba(0, 0, 0, .2);
    margin-top: 3px;
    font-weight: 600;
    text-transform: uppercase;
    padding: 4px;
    line-height: 1.2;
    font-size: .71rem;
    border-radius: 2px;
    z-index: 100;
    position: absolute;
    top: 100%;
    left: 0;
  }
}
</style>
